export default function Footer() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="relative bg-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="text-2xl font-heading text-primary-500 whitespace-nowrap">豆花视频</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                聚合香蕉视频、红桃视频、蜜桃视频等美食命名视频平台，免费高清在线观看电视剧全集和最新电影，畅快追剧不缓冲。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-300/50 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-300/50 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-300/50 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer">
                  <i className="ri-bilibili-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">快速导航</h3>
              <nav className="flex flex-col gap-2.5">
                <a href="#hero" onClick={(e) => handleScrollTo(e, '#hero')} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</a>
                <a href="#features" onClick={(e) => handleScrollTo(e, '#features')} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">平台特色</a>
                <a href="#updates" onClick={(e) => handleScrollTo(e, '#updates')} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">最新快讯</a>
                <a href="#ranking" onClick={(e) => handleScrollTo(e, '#ranking')} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">热度榜单</a>
                <a href="#faq" onClick={(e) => handleScrollTo(e, '#faq')} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              </nav>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">合作平台</h3>
              <nav className="flex flex-col gap-2.5">
                <span className="text-sm text-foreground-600 whitespace-nowrap">香蕉视频</span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">红桃视频</span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">蜜桃视频</span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">西瓜视频</span>
                <span className="text-sm text-foreground-600 whitespace-nowrap">糖豆视频</span>
              </nav>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4">合作伙伴</h3>
              <nav className="flex flex-col gap-2.5">
                <span className="text-sm text-foreground-400 whitespace-nowrap">更多合作伙伴即将加入</span>
              </nav>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-300/60">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                &copy; 2024-2026 豆花视频 douhua.example.com 版权所有
              </p>
              <div className="flex items-center gap-4">
                <a
                  href="#about"
                  onClick={(e) => handleScrollTo(e, '#about')}
                  className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  关于我们
                </a>
                <a
                  href="#contact"
                  onClick={(e) => handleScrollTo(e, '#contact')}
                  className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  联系我们
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}